import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { AlloyGatorSection } from '../components/AlloyGatorSection';
import { HighlightSection } from '../components/HighlightSection';
import { PortfolioSection } from '../components/PortfolioSection';
import { USPSection } from '../components/USPSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { CTASection } from '../components/CTASection';
import { SEOTextSection } from '../components/SEOTextSection';
import { SEO } from '../components/SEO';
export const HomePage = () => {
  return <main data-id="element-1528">
      <SEO title="BK Customs Almere | Ramen Blinderen & Auto Wrappen in Almere" description="Premium auto styling in Almere: ramen tinten, car wrapping, lichten smoken en ontchromen. Professionele service met 5-sterren beoordelingen. Maak direct een afspraak!" canonical="/" data-id="element-1529" />
      <HeroSection data-id="element-1530" />
      <ServicesSection data-id="element-1531" />
      <AlloyGatorSection data-id="element-1532" />
      <HighlightSection data-id="element-1533" />
      <PortfolioSection data-id="element-1534" />
      <USPSection data-id="element-1535" />
      <ReviewsSection data-id="element-1536" />
      <SEOTextSection data-id="element-1537" />
      <CTASection data-id="element-1538" />
    </main>;
};